export function useMessageHandler(message: string): string {
  // const { t } = useI18n()

  console.log('message', message)

  message = message.replace('ApolloError: ', '')

  // Should we run evvery message over a translator? Is there a risc for translating twice?
  // return t(message)

  return message
}
